<template>
  <div class="layer layer--block">
    <div class="layer--block__title">
      <h3>{{ layer.name }}</h3>
      <button
        role="button"
        class="button button--toggle"
        :class="{ 'active' : isVisibleOrActive }"
        :title="$t('layer_toggle')"
        v-if="isToggleable && !isStatic"
        tabindex="-1"
        @click="onToggleLayer"
      >{{ $t('layer_toggle') }}</button>
    </div>
    <div class="layer--block__content" v-if="isVisibleOrActive">
      <form action method="POST" novalidation>
        <div class="grid-x grid-margin-x">
          <div class="cell large-3">
            <div v-if="isStatic" class="form-group">
              <div
                class="form-control form-control--static form-control--small"
              >{{ $t('placementtype.' + value.$model.placement_type) }}</div>
            </div>
            <div
              v-else
              class="form-group"
              :class="{ 'form-group--error' : value.placement_type.$error  }"
            >
              <v-select-layer-placement-type
                name="placement_type"
                class="form-control--small"
                :placeholder="$t('form.project.layer.placement_type.plc')"
                v-model="value.$model.placement_type"
                @change="onChangePlacementType"
              />
            </div>
          </div>
          <div class="cell large-4">
            <div v-if="isStatic" class="form-group">
              <div
                class="form-control form-control--static form-control--small"
              >{{ value.$model.subtype }}</div>
            </div>
            <div v-else class="form-group" :class="{ 'form-group--error' : value.subtype.$error  }">
              <v-select-layer-sub-type
                name="subtype"
                :type="layer.layer_key"
                :className="'form-control--small ' + defaultSubTypeClass"
                :placeholder="$t('form.project.layer.subtype.plc')"
                v-model="value.$model.subtype"
                @change="onUpdateLayerSubType"
              />
            </div>
          </div>
          <div class="cell large-2">
            <div v-if="isStatic" class="form-group">
              <div
                class="form-control form-control--static form-control--small"
              >{{ value.$model.thickness }} {{ $t('cm') }}</div>
            </div>
            <div
              v-else
              class="form-group"
              :class="{ 'form-group--error' : value.thickness.$error }"
            >
              <input
                type="text"
                name="thickness"
                class="form-control form-control--small"
                :placeholder="$t('form.project.layer.thickness.plc')"
                v-model="value.$model.thickness"
              />
            </div>
          </div>
          <div class="cell large-3">
            <div v-if="isStatic" class="form-group">
              <div
                class="form-control form-control--static form-control--small"
              >{{ value.$model.qm }} {{ $t('qm') }}</div>
            </div>
            <div v-else class="form-group" :class="{ 'form-group--error' : value.qm.$error  }">
              <input
                type="text"
                name="qm"
                class="form-control form-control--small"
                :placeholder="$t('form.project.layer.area.plc')"
                v-model="value.$model.qm"
              />
            </div>
          </div>
        </div>
        <template v-if="isStatic">
          <div class="grid-x grid-margin-x" v-for="(log, index) in logs" :key="index">
            <div class="cell large-6">
              <div class="form-group">
                <div class="form-control form-control--static-hidden form-control--small">
                  <span class="status-icon" :class="'status-icon--' + log.status"></span>
                  <strong>{{ $t('status.' + log.status) }}</strong>
                </div>
              </div>
            </div>
            <div class="cell large-3">
              <div class="form-group">
                <div class="form-control form-control--static-hidden form-control--small">
                  <template
                    v-if="log.date.date !== null"
                  >{{ log.date.date | moment($helpers.dateFormat.toUpperCase()) }}</template>
                </div>
              </div>
            </div>
            <div class="cell large-3">
              <div class="form-group">
                <div
                  class="form-control form-control--static-hidden form-control--small"
                >{{ log.qm }} {{ $t('qm') }}</div>
              </div>
            </div>
          </div>
        </template>
      </form>
    </div>
  </div>
</template>

<script>
import SelectLayerPlacementType from "./../../partials/Forms/SelectLayerPlacementType";
import SelectLayerSubType from "./../../partials/Forms/SelectLayerSubType";

export default {
  props: {
    layer: {
      type: Object,
      required: true
    },
    projectId: {
      type: Number,
      required: true
    },
    value: {
      type: Object,
      default() {
        return {};
      }
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    isStatic: {
      type: Boolean,
      default: false
    },
    isToggleable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    vSelectLayerPlacementType: SelectLayerPlacementType,
    vSelectLayerSubType: SelectLayerSubType
  },
  data() {
    return {
      logs: [],
      total: 0,
      finished: 0,
      open: 0,
      defaultSubType: "",
      defaultSubTypeClass: ""
    };
  },
  computed: {
    isVisibleOrActive: function() {
      if (this.value.$model) {
        this.isVisible = true;
      }

      return this.isVisible;
    }
  },
  watch: {
    value: {
      handler: function(newVal, oldVal) {
        this.onUpdateLayerLogs();
      },
      deep: true
    }
  },
  created: function() {
    this.onUpdateLayerLogs();
  },
  methods: {
    onUpdateFields: function() {
      this.$emit("changeField");
    },
    onToggleLayer: function() {
      if (!this.isStatic) {
        this.isVisible = !this.isVisible;

        this.value.project_id = this.projectId;
        this.value.layer_type = this.layer;
        this.value.status = "open";

        if (!this.isVisible) {
          this.value.$model.placement_type = 0;
          this.value.$model.subtype = "";
          this.value.$model.qm = "";
          this.value.$model.thickness = "";
        }

        this.$emit("change", this.isVisible, this.layer.id, this.value);
      }
    },
    onChangePlacementType: function(type) {
      if (this.layer.layer_key === "layer") {
        var defaultSubType = "";

        if (type.type === "street") {
          defaultSubType = "AC 8 DN / 70/100";
        } else if (type.type === "sidewalk") {
          defaultSubType = "AC 5 DL / 70/100";
        }

        this.defaultSubType = defaultSubType;
        this.defaultSubTypeClass = "";
        this.value.$model.subtype = defaultSubType;
      }
    },
    onUpdateLayerLogs: function() {
      if (this.value.$model) {
        this.logs = [];
        this.total = parseInt(this.value.$model.qm);
        this.finished = 0;

        if (this.value.$model.layer_logs) {
          this.value.$model.layer_logs.forEach(
            function(log) {
              this.finished += parseInt(log.qm);

              log.status = "busy";

              this.logs.push(log);
            }.bind(this)
          );
        }

        if (
          this.value.$model.status === "finished" ||
          this.value.$model.status === "finished_manual"
        ) {
          this.logs = [
            {
              status: "finished",
              qm: this.finished,
              date: {
                date: this.value.$model.status_date.date
              }
            }
          ];
        } else {
          this.open = this.total - this.finished;

          this.logs.push({
            status: "open",
            qm: this.open,
            date: {
              date: null
            }
          });
        }
      }
    },
    onUpdateLayerSubType: function(type) {
      if (this.defaultSubType !== "") {
        if (type) {
          if (type.id !== this.defaultSubType) {
            this.defaultSubTypeClass = "form-control--warning";
          } else {
            this.defaultSubTypeClass = "";
          }
        } else {
          this.defaultSubTypeClass = "form-control--warning";
        }
      }
    }
  }
};
</script>